import { connect } from 'react-redux';
import noop from '../../utils/noop';
import { ChatWindowMode } from '../ChatWindow/types';
import { changeChatroomWindowMode, initializeChatroomModeManage, openChatroom, leaveChatroom, deleteChatroom, closeChatPanel, } from '../redux/actions';
import { getCurrentUser } from '../../publicSession';
var mapStateToProps = function (state) { return ({
    currentUser: getCurrentUser(state),
}); };
var mapDispatchToProps = function (dispatch, _a) {
    var inChatWindow = _a.inChatWindow;
    // When triggering actions from the header chat dropdown we need to make sure the corresponding chat window
    // is open before doing anything.
    // When the action is called from within a chat window this is not necessary.
    var openChatAndDispatch = function (chatId, action) {
        if (!inChatWindow) {
            dispatch(openChatroom(chatId));
            dispatch(closeChatPanel());
        }
        dispatch(action);
    };
    return {
        // TODOLATER: Hiding for now since the future of this is unclear
        onAddToWatch: noop,
        onBlockUser: function (chatId) {
            return openChatAndDispatch(chatId, changeChatroomWindowMode(chatId, ChatWindowMode.BLOCK_USER));
        },
        // TODOLATER: Can't do this right now. Replace this when we can
        onReportUser: noop,
        onRemove: function (chatId) {
            if (!inChatWindow) {
                return dispatch(deleteChatroom(chatId, !inChatWindow));
            }
            openChatAndDispatch(chatId, changeChatroomWindowMode(chatId, ChatWindowMode.REMOVE));
        },
        onLeave: function (chatId) {
            dispatch(leaveChatroom(chatId, undefined, true));
        },
        onCreateGroupChat: function (chatId) {
            return openChatAndDispatch(chatId, changeChatroomWindowMode(chatId, ChatWindowMode.CREATE_GROUP_CHAT));
        },
        onManage: function (chatId) {
            return openChatAndDispatch(chatId, initializeChatroomModeManage(chatId));
        },
        onRename: function (chatId) {
            return openChatAndDispatch(chatId, changeChatroomWindowMode(chatId, ChatWindowMode.RENAME));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ChatActionsIconWithDropdown.container.js.map